import type { TimelineItem } from "@/mocks/events";

const tagClass: Record<TimelineItem["tag"], string> = {
  公告: "bg-primary-100 text-primary-800",
  回应: "bg-accent-100 text-accent-800",
  媒体报道: "bg-secondary-100 text-secondary-800",
  网友讨论: "bg-background-200 text-foreground-600",
};

export default function Timeline({ items }: { items: TimelineItem[] }) {
  return (
    <section id="sec-timeline" className="scroll-mt-20">
      <h2 className="flex items-center gap-2.5 font-heading text-xl font-black text-foreground-950 md:text-2xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
          <i className="ri-time-line" aria-hidden="true"></i>
        </span>
        事件时间线
      </h2>
      <p className="mt-2 text-sm text-foreground-600">
        按时间先后展开，每个节点都标注信息来源类型，方便你判断哪一环该多看一眼。
      </p>

      <ol className="mt-8 space-y-0">
        {items.map((it, idx) => (
          <li key={idx} className="relative flex gap-5 pb-8 last:pb-0">
            {/* 左侧时间 */}
            <div className="flex w-20 shrink-0 flex-col items-end pt-0.5 sm:w-28">
              <span className="rounded-md bg-background-100 px-2 py-1 text-right text-xs font-semibold leading-tight text-foreground-700">
                {it.time}
              </span>
            </div>

            {/* 竖线与节点 */}
            <div className="relative flex flex-col items-center">
              <span className="mt-1 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
              </span>
              {idx < items.length - 1 && (
                <span className="mt-1 w-px flex-1 bg-background-200"></span>
              )}
            </div>

            {/* 内容 */}
            <div className="min-w-0 flex-1 pb-1">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-900">{it.title}</h3>
                <span
                  className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${tagClass[it.tag]}`}
                >
                  {it.tag}
                </span>
              </div>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{it.detail}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}